import React from 'react';
import { useLocation } from 'react-router-dom';
import SEO from './SEO';

// Public pages set their own SEO from src/config/seoRoutes.json (via getRouteSeo).
// This component only keeps the admin area out of search engines.
const RouteSEO = () => {
  const { pathname } = useLocation();

  if (!pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <SEO
      title="Admin | Dangi Innovation Lab"
      description="Administrative area"
      noIndex
      noFollow
    />
  );
};

export default RouteSEO;
